export default {"src":"/_next/static/media/schaken.bc2d5129.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};